import React, { useState, useEffect } from 'react';
import styles from './videoCollect.module.scss';
import { SearchBar, Picker, List, ActivityIndicator, ListView, PullToRefresh, Modal, TabBar, Toast } from 'antd-mobile';
import { createFromIconfontCN, DashOutlined } from '@ant-design/icons';
import { ApiCore } from '../../api/index';
import icon_completed from '../../static/images/icon-completed.png';
import icon_failed from '../../static/images/icon-failed.png';
import icon_ing from '../../static/images/icon-ing.png';
import icon_not_signed from '../../static/images/icon-not-signed.png';
import icon_reviewed from '../../static/images/icon-reviewed.png';
import icon_to_be_reviewed from '../../static/images/icon-to-be-reviewed.png';
import icon_plus from '../../static/images/icon-plus.png';
import icon_search from '../../static/images_doctor/tool_introdce_search.png';
import icon_search_clear from '../../static/images_medicalLive/search_clear.png';
import icon_task_video_collect from '../../static/images_doctor/icon_task_video_collect.png';
import icon_task_project_research from '../../static/images_doctor/icon_task_project_research.png';
import icon_task_questionnaire_collect from '../../static/images_doctor/icon_task_questionnaire_collect.png';
import no_task_contact_admin from '../../static/images_doctor/no_task_contact_admin.png';
import { withRouter } from 'react-router-dom';
import utils from '../../utils/utils';

const api = new ApiCore();
const alert = Modal.alert;

//设置阿里图库地址
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2323742_xvjwsudf76n.js',
});

let delayExcute: any = null;

function Home(props: any) {
    let projectCode = utils.getUrlParams().projectCode;
    let projectName = utils.getUrlParams().projectName;
    let projectType = utils.getUrlParams().projectType;
    projectName = projectName ? decodeURIComponent(projectName) : projectName;

    let token = sessionStorage.getItem('token');
    let mToken: any = {};
    if (token) {
        try {
            mToken = JSON.parse(token);
        } catch (error) {
            mToken = {};
        }
    }

    //设置加载状态
    const [loading, setLoading] = useState<any>(null);
    //设置当前页数
    const [page, setPage] = useState<number>(1);
    //设置pageSize
    const [pageSize, setPageSize] = useState<number>(20);
    //搜索关键字
    const [searchKey, setSearchKey] = useState('');
    //项目list
    const [projectList, setProjectList] = useState([]);
    //选择的项目
    const [urlProjectCode, setUrlProjectCode] = useState<any>(projectCode ? projectCode : '');
    //选择的项目
    const [selectProject, setSelectProject] = useState<any>(projectCode ? [projectCode] : []);
    //选择的项目名称
    const [urlProjectName, setUrlProjectName] = useState<any>(projectName ? projectName : '');
    //选择的项目类型
    const [urlProjectType, setUrlProjectType] = useState<any>(projectType ? projectType : '');
    //选择的状态
    const [selectType, setSelectType] = useState<any>(['All']);
    //受试者列表数据
    const [subjectList, setSubjectList] = useState<Array<any>>([]);
    //是否还有更多数据
    const [isMore, setIsMore] = useState<boolean>(true);
    //当前排序规则
    const [currentSort, setCurrentSort] = useState<any>(null);
    // //下拉刷新状态
    const [isPullToRefresh, setIsPullToRefresh] = useState<boolean>(false);
    // 搜索时遮罩层是否打开
    const [isShowMask, setIsShowMask] = useState<boolean>(false);
    //搜索历史记录
    const [record, setRecord] = useState<any>([]);
    // 切换tab
    const [selectedTab, setSelectedTab] = useState<any>('mine');
    // 发现页状态 false-隐藏，true-显示
    const [menuStatus, setMenuStatus] = useState<boolean>(false);
    // 
    const [userId, setUserId] = useState<any>(null);
    //项目加载对应类型映射
    const [projectTypeMap, setProjectTypeMap] = useState({});
    //用户角色，跟用户有关，跟项目有关
    const [roleCode, setRoleCode] = useState('');
    //项目统计
    const [statistics, setStatistics] = useState([]);
    const [activeStaticsIndex, setActiveStaticsIndex] = useState(0);
    const [displayType, setDisplayType] = useState('all');
    //总任务数
    const [taskCountAll, setTaskCountAll] = useState(-1);

    useEffect(() => {

        let localStorage_accountInf = localStorage.getItem('accountInf');
        if (localStorage_accountInf) {
            let accountInf = JSON.parse(localStorage_accountInf);
            setUserId(accountInf.account)
        }
        // 初始化上次选择过的roleCode
        let token = sessionStorage.getItem('token');
        if (token) {
            let mToken = JSON.parse(token);
            if (mToken.roleCode) {
                setRoleCode(mToken.roleCode);
            }
        }
        return () => {
        }
    }, [])

    useEffect(() => {
        clearTimeout(delayExcute);
        if (searchKey !== null) {
            delayExcute = setTimeout(() => {
                setPage(1);
                getTasks(1, true);
            }, 300);
        }
    }, [searchKey])

    useEffect(() => {
        const urlParams = utils.getUrlParams() || {};
        //设置网页title
        document.title = urlParams.projectName ? decodeURIComponent(urlParams.projectName) : '';
        let _project = projectCode || '';
        toGetSubjectStatistics(_project);
    }, [])

    const toGetSubjectStatistics = (projectCode = '') => {
        const _param: any = {}
        if (projectCode) {
            _param.projectCode = projectCode || selectProject[0] || '';
        }
        api.getSubjectStatistics(_param).then((res: any) => {
            if (res.code == 0) {
                const _data = res.data || {};
                const _displays = _data.displays || [];
                const _values = _data.values || {};
                setTaskCountAll(_values.all);
                const _statistics = _displays.map((val: any) => {
                    const _count = _values[val.code];
                    if (_count !== undefined) {
                        return {
                            ...val,
                            count: _count,
                            isValid: true
                        }
                    }
                    return {
                        isValid: false
                    }
                }).filter((v: any) => v.isValid);
                setStatistics(_statistics);
            }
        })
    }

    // 搜索标题变化
    const titleInput = (event: any) => {
        setSearchKey(event.target.value);
    }

    // 清除输入内容
    const clearInput = () => {
        setSearchKey('');
    }

    //根据条件搜索待处理任务列表
    const getTasks = (currentPage?: number, isReset?: boolean, nowDisplayType?: '') => {
        setLoading(true);
        let params = {
            page: currentPage ? currentPage : page,
            pageSize: pageSize,
            type: selectType[0],
            subjectCode: searchKey ? searchKey : null,
            subjectCodeOrder: currentSort,
            displayType: nowDisplayType ? nowDisplayType : displayType,
            projectCode: utils.getUrlParams().projectCode || ''
        }
        //重置状态
        setIsMore(true)
        api.getTasksList(params).then(res => {
            if (res.code == '0') {
                let subjectArr = res.data;
                setIsMore(subjectArr.length === pageSize)
                //重置
                if (isReset) {
                    setPage(subjectArr.length === pageSize ? 2 : 1);
                    setSubjectList(subjectArr);
                }
                else {
                    setPage(subjectArr.length === pageSize ? page + 1 : page);
                    setSubjectList([...subjectList, ...subjectArr]);
                }
            }
            setLoading(false);
        })
    }

    //当点击列表item
    const onClickListItem = (item: any) => {
        return () => {
            // 记录点击条目数据
            item && sessionStorage.setItem('toPhotoEditItem', JSON.stringify(item));
            if (item.subjectState === 'Init') {
                props.history.push({ pathname: `/checkSubject/${item.subjectCode}?projectType=${item.projectType}` })
                sessionStorage.removeItem('currentState');
            }
            else {
                if (roleCode === 'EDC_DRE') {
                    props.history.push({ pathname: `/subjectsDetailComment/${item.subjectCode}?projectType=${item.projectType}&projectCode=${projectCode}` })
                    sessionStorage.removeItem('currentState');
                } else {
                    props.history.push({ pathname: `/subjectsDetail/${item.subjectCode}?projectType=${item.projectType}&projectCode=${projectCode}` })
                    sessionStorage.removeItem('currentState');
                }
            }
        }
    }

    //当进度长度为一条时
    const switchProgress = (progress: any) => {
        if (progress) {
            switch (progress[0]) {
                case 'Complete':
                    return (
                        <span style={{ backgroundColor: '#6c96f7', maxWidth: '0.8rem' }}></span>
                    )
                case 'Running':
                    return (
                        <span style={{ backgroundColor: '#5ebcbc', maxWidth: '0.8rem' }}></span>
                    )
                case 'Question':
                    return (
                        <span style={{ backgroundColor: '#ef8767', maxWidth: '0.8rem' }}></span>
                    )
                case 'Wait':
                    return (
                        <span style={{ backgroundColor: '#e6ebf5', maxWidth: '0.8rem' }}></span>
                    )
                case 'Answer':
                    return (
                        <span style={{ backgroundColor: '#477291', maxWidth: '0.8rem' }}></span>
                    )
                default:
                    break;
            }
        }
        else {
            return null
        }
    }

    //处理task状态
    const handleTask = (item: any) => {
        switch (item.type) {
            case 'Check':
                return (
                    <span style={{ color: '#FF8C69' }}>{item.message}</span>
                )
                break;
            case 'Question':
                return (
                    <span style={{ color: '#FF8C69' }}>{item.message}</span>
                )
                break;
            case 'Examine':
                return (
                    <span style={{ color: '#FF8C69' }}>{item.message}</span>
                )
                break;
            case 'Answer':
                return (
                    <span style={{ color: '#eab426' }}>{item.message}</span>
                )
                break;
            default:
                return (
                    <span style={{ color: 'rgb(94, 188, 188)' }}>{item.message}</span>
                )
                break;
        }
    }

    //处理task颜色
    const handleTaskColor = (item: any) => {
        let _targetColor: any = {};
        switch (item.type) {
            case 'Check':
            case 'Question':
            case 'Examine':
                _targetColor = {
                    type: 'orange',
                    color: '#FF8C69'
                };
                break;
            case 'Answer':
                _targetColor = {
                    type: 'yellow',
                    color: '#eab426'
                };
                break;
            default:
                _targetColor = {
                    type: 'green',
                    color: 'rgb(94, 188, 188)'
                };
                break;
        }
        return _targetColor;
    }

    // 质疑排序
    const sortMethods = (data: any) => {
        data && data.length > 0 && data.map((dataItem: any, dataIndex: any) => {
            dataItem.tasks && dataItem.tasks.length > 0 && dataItem.tasks.map((taskItem: any, taskIndex: any) => {
                if (taskItem.type == "Answer") {
                    dataItem.tasks[0] = taskItem
                }
            })
        })
        return data
    }

    const avatarRender = (val: any) => {
        let _img = null;
        if (val.projectType === 'VIDEOSOLICIT') {
            _img = icon_task_video_collect;
        } else if (val.projectType === 'QUESTIONSURVEY') {
            _img = icon_task_questionnaire_collect;
        } else if (val.projectType === 'CASESOLICIT') {
            // 病例征集
            _img = icon_task_project_research;
        } else if (val.projectType === 'LISTEDSTYDY') {
            // 调查研究
            _img = icon_task_project_research;
        } else {
            _img = icon_task_project_research;
        }
        return _img;

    }

    const dataView = new ListView.DataSource({
        rowHasChanged: (row1: any, row2: any) => row1 !== row2,
    });

    const dataSource = dataView.cloneWithRows(sortMethods(subjectList));

    const row = (item: any) => (
        <div className={styles.list} onClick={onClickListItem(item)}>
            <div className={styles.listItem}>
                <div className={styles.portrait}>
                    <img src={avatarRender(item)} alt="defaultAvatar" />
                </div>
                <div className={styles.info_content}>
                    <div className={styles.info_top}>
                        {item.subjectName ? (
                            <div className={styles.id}>
                                <div className={styles.subName}>{item.subjectName}</div>
                                <div className={styles.subCode}>（&nbsp;{item.subjectCode}&nbsp;）</div>
                            </div>
                        ) : (
                            <div className={styles.id}>{item.subjectCode}</div>
                        )}
                        {/* <div className={styles.name_wrap}> */}
                        <div className={styles.name}>{item.createUser}</div>
                        {/* </div> */}
                        {
                            roleCode === 'EDC_DRE' && item.commentState &&
                            <div className={item.commentState === 'Finish' ? styles.commentStateFinish : styles.commentStateWait}>
                                <div className={styles.dot}></div>
                                {item.commentState === 'Finish' ? '已点评' : item.commentState === 'Wait' ? '待点评' : ''}
                            </div>
                        }
                        <div style={{ flex: 1 }}></div>
                        {
                            item.auditState !== null &&
                            <div className={styles.banner_text_new}>
                                {
                                    item.auditState == 'Pass' &&
                                    <>
                                        <img src={icon_reviewed} alt="" />
                                        <span className={styles.color_reviewed}>
                                            已审核
                                        </span>
                                    </>
                                }
                                {
                                    item.auditState == 'Wait' &&
                                    <>
                                        <img src={icon_to_be_reviewed} alt="" />
                                        <span className={styles.color_to_be_reviewed}>
                                            待审核
                                        </span>
                                    </>
                                }
                                {
                                    item.auditState == 'Fail' &&
                                    <>
                                        <img src={icon_failed} alt="" />
                                        <span className={styles.color_failed}>
                                            未通过
                                        </span>
                                    </>
                                }
                            </div>
                        }
                        {
                            item.subjectState === 'Finish' && item.signState == 'Wait' ?
                                <div className={styles.banner_text_new}>
                                    <img src={icon_not_signed} alt="" />
                                    <span className={styles.color_complete}>
                                        未签名
                                    </span>
                                </div>
                                : item.subjectState === 'Finish' && item.auditState === null ?
                                    <div className={`${styles.banner_text_new}`}>
                                        <img src={icon_completed} alt="" />
                                        <span className={styles.color_complete}>
                                            已完成
                                        </span>
                                    </div>
                                    : item.subjectState === 'Active' && item.auditState === null ?
                                        <div className={`${styles.banner_text_new}`}>
                                            <img src={icon_ing} alt="" />
                                            <span className={styles.color_ing}>
                                                进行中
                                            </span>
                                        </div>
                                        : null
                        }
                        {/* icon_ing */}

                    </div>
                    {
                        item.tasks && item.tasks[0] && handleTask(item.tasks[0]) && renderIconFont(item.tasks[0]) && urlProjectType === 'LISTEDSTYDY' &&
                        <div className={`${styles.prompt_wrap}`} >
                            <div className={`${styles.prompt} ${styles[handleTaskColor(item.tasks[0]).type]}`} >
                                <div className={styles.action}>
                                    {
                                        item.auditState === 'Fail' &&
                                        <span className={styles.answer}>!</span>
                                    }
                                    {item.auditState !== 'Fail' &&
                                        renderIconFont(item.tasks[0])
                                    }
                                </div>
                                {item.auditState === 'Fail' && roleCode !== 'EDC_DRE' && <span style={{ color: '#eab426' }}>您的任务审核未通过</span>}
                                {
                                    ((item.auditState !== 'Fail' && item.commentState !== 'Finish') || item.commentState === 'Wait') && item.tasks && item.tasks.length > 0 ? handleTask(item.tasks[0]) : null
                                }
                            </div>
                        </div>
                    }
                    {
                        urlProjectType === 'LISTEDSTYDY' &&
                        <div className={styles.info_bottom}>
                            {
                                item.progress && item.progress.length > 1 ? item.progress.map((pro: any, i: any) => {
                                    switch (pro) {
                                        case 'Complete':
                                            return (
                                                <span key={i} style={{ backgroundColor: '#6c96f7' }}></span>
                                            )
                                        case 'Running':
                                            return (
                                                <span key={i} style={{ backgroundColor: '#5ebcbc' }}></span>
                                            )
                                        case 'Question':
                                            return (
                                                <span key={i} style={{ backgroundColor: '#ef8767' }}></span>
                                            )
                                        case 'Wait':
                                            return (
                                                <span key={i} style={{ backgroundColor: '#e6ebf5' }}></span>
                                            )
                                        case 'Answer':
                                            return (
                                                <span key={i} style={{ backgroundColor: '#477291' }}></span>
                                            )
                                        default:
                                            break;
                                    }
                                }) : <React.Fragment>
                                    {
                                        switchProgress(item.progress)
                                    }
                                    {
                                        item.progress && item.progress.length > 0 ? <span className={styles.extra} style={{ backgroundColor: '#E6EBF5' }}></span> : null
                                    }
                                </React.Fragment>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
    )

    //下拉触底
    const onEndReached = () => {
        if (isMore) {
            //加载数据
            getTasks()
        }
    }

    // 渲染图标
    const renderIconFont = (stateItem: any) => {
        // 系统核查
        if (stateItem.type === 'Check') {
            switch (stateItem.state) {
                case 'Complete':
                    return (
                        <IconFont type="iconCheck_Complete"></IconFont>
                    )
                case 'Wait':
                    return (
                        <IconFont type="iconCheck_Wait"></IconFont>
                    )
                case 'Running':
                    return (
                        <IconFont type="iconCheck_Running"></IconFont>
                    )
                case 'Question':
                    return (
                        <IconFont type="iconCheck_Question"></IconFont>
                    )
                default:
                    break;
            }
        }
        //录入
        else if (stateItem.type === 'Input') {
            switch (stateItem.state) {
                case 'Complete':
                    return (
                        <IconFont type="iconInput_Complete"></IconFont>
                    )
                case 'Wait':
                    return (
                        <IconFont type="iconInput_Wait"></IconFont>
                    )
                case 'Running':
                    return (
                        <IconFont type="iconInput_Running"></IconFont>
                    )
                default:
                    break;
            }
        }
        //人工核查
        else if (stateItem.type === 'Question') {
            switch (stateItem.state) {
                case 'Complete':
                    return (
                        <IconFont type="iconQuestion_Complete"></IconFont>
                    )
                case 'Wait':
                    return (
                        <IconFont type="iconQuestion_Wait"></IconFont>
                    )
                case 'Running':
                    return (
                        <IconFont type="iconQuestion_Running"></IconFont>
                    )
                case 'Question':
                    return (
                        <IconFont type="iconQuestion_Question"></IconFont>
                    )
                case 'Answer':
                    return (
                        <IconFont type="iconQuestion_Answer"></IconFont>
                    )
                default:
                    break;
            }
        }
        //数据审查
        else if (stateItem.type === 'Examine') {
            switch (stateItem.state) {
                case 'Complete':
                    return (
                        <IconFont type="iconExamine_Complete"></IconFont>
                    )
                case 'Wait':
                    return (
                        <IconFont type="iconExamine_Wait"></IconFont>
                    )
                case 'Running':
                    return (
                        <IconFont type="iconExamine_Running"></IconFont>
                    )
                case 'Question':
                    return (
                        <IconFont type="iconExamine_Question"></IconFont>
                    )
                case 'Answer':
                    return (
                        <IconFont type="iconExamine_Answer"></IconFont>
                    )
                default:
                    break;
            }
        }
        //冻结
        else if (stateItem.type === 'Freeze') {
            switch (stateItem.state) {
                case 'Complete':
                    return (
                        <IconFont type="iconFreeze_Complete"></IconFont>
                    )
                case 'Wait':
                    return (
                        <IconFont type="iconFreeze_Wait"></IconFont>
                    )
                case 'Running':
                    return (
                        <IconFont type="iconFreeze_Running"></IconFont>
                    )
                default:
                    break;
            }
        }
        //签名
        else if (stateItem.type === 'Autograph') {
            switch (stateItem.state) {
                case 'Complete':
                    return (
                        <IconFont type="iconAutograph_Complete"></IconFont>
                    )
                case 'Wait':
                    return (
                        <IconFont type="iconAutograph_Wait"></IconFont>
                    )
                case 'Running':
                    return (
                        <IconFont type="iconAutograph_Running"></IconFont>
                    )
                default:
                    break;
            }
        }
        //锁定
        else if (stateItem.type === 'Lock') {
            switch (stateItem.state) {
                case 'Complete':
                    return (
                        <IconFont type="iconLock_Complete"></IconFont>
                    )
                case 'Wait':
                    return (
                        <IconFont type="iconLock_Wait"></IconFont>
                    )
                case 'Running':
                    return (
                        <IconFont type="iconLock_Running"></IconFont>
                    )
                default:
                    break;
            }
        }
        //质疑
        else if (stateItem.type === 'Answer') {
            switch (stateItem.state) {
                case 'Question':
                    return (
                        <span className={`${styles.answer}`}>!</span>
                    )
                default:
                    break;
            }
        }
    }

    const statisticsSelect = (val: any, index: number) => {
        setActiveStaticsIndex(index);
        setDisplayType(val.type);
        getTasks(1, true, val.type);
    }

    const headBgRender = () => {
        let _styleClass = null;
        if (projectType === 'VIDEOSOLICIT') {
            _styleClass = styles.bg_head_video;
        } else if (projectType === 'CASESOLICIT') {
            _styleClass = styles.bg_head_case_collect;
        } else if (projectType === 'QUESTIONSURVEY') {
            _styleClass = styles.bg_head_question_survey;
        } else if (projectType === 'LISTEDSTYDY') {
            _styleClass = styles.bg_head_project_research;
        } else {
            _styleClass = styles.bg_head_project_research;
        }
        return _styleClass;
    }

    return (
        <div className={`${styles.findTabItem} ${menuStatus ? '' : styles.hide_menu_btn}`}>
            <div className={styles.home_content}>
                <div className={`${styles.bg_head} ${headBgRender()}`}>
                    <div>
                        {urlProjectName}
                    </div>
                </div>
                <div className={styles.body}>
                    <div className={styles.body_head}>

                        <div className={styles.task_list_search_header}>
                            <div className={styles.head}>
                                <div className={styles.title}>
                                    我的任务
                                </div>
                                <div className={styles.search}>
                                    <div className={`${styles.tool_introduce_head}`}>
                                        <div className={styles.search_head}>
                                            <div className={styles.search}>
                                                <img className={styles.search_img} src={icon_search} alt="" />
                                                <input type="text" placeholder="输入编号进行查找" value={searchKey} onChange={(event) => { titleInput(event) }} />
                                                {
                                                    searchKey &&
                                                    <img className={`${styles.search_img_clear}`} src={icon_search_clear} alt="" onClick={() => { clearInput() }} />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.add_task_wrap} style={{ display: mToken.roleCode == 'ReadOnly' ? 'none' : '' }} onClick={() => { props.history.push(`/addSubject?projectCode=${urlProjectCode}`); }}>
                                    <div className={styles.add_task}>
                                        <img src={icon_plus} alt="" />
                                        <span className={styles.add_task_text}>添加任务</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            statistics && (statistics.length > 0) &&
                            <div className={styles.all_statics}>
                                {
                                    statistics && statistics.map((val: any, index) => (
                                        <div key={index} style={{ width: statistics.length <= 5 ? ((1 / statistics.length) * 100 + '%') : '20%' }}
                                            className={activeStaticsIndex === index ? styles.statics_active : ''}
                                            onClick={() => { statisticsSelect(val, index) }}
                                        >
                                            <div>{val.name}</div>
                                            <div>{val.count}</div>
                                        </div>
                                    ))
                                }
                            </div>
                        }

                    </div>

                    <div className={`${styles.List_content} ${props.bottomMore ? styles.list_content_more : ''}`}>
                        {
                            subjectList.length === 0 && loading === false &&
                            <div className={styles.no_task_contact_admin}>
                                <img src={no_task_contact_admin} alt="no_task_contact_admin" />
                                {
                                    taskCountAll === 0 &&
                                    <div className={styles.add_task_wrap_wrap} style={{ display: mToken.roleCode == 'ReadOnly' ? 'none' : '' }}>
                                        <div className={styles.add_task_wrap} onClick={() => { props.history.push(`/addSubject?projectCode=${urlProjectCode}`); }}>
                                            <div className={styles.add_task}>
                                                <img src={icon_plus} alt="" />
                                                <span className={styles.add_task_text}>添加任务</span>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                        <ListView
                            // style={{ height: 'calc(100vh - 3.04rem)' }}
                            style={{ height: props.bottomMore ? 'calc(100vh - 7.1rem)' : 'calc(100vh - 5.98rem)' }}
                            dataSource={dataSource}
                            renderRow={row}
                            initialListSize={2000}
                            onEndReached={onEndReached}
                            onEndReachedThreshold={6}
                            scrollRenderAheadDistance={500}
                            scrollEventThrottle={200}
                            useBodyScroll={false}
                        // pullToRefresh={
                        //     <PullToRefresh
                        //         damping={60}
                        //         distanceToRefresh={25}
                        //         indicator={{}}
                        //         direction="down"
                        //         refreshing={isPullToRefresh}
                        //         getScrollContainer={() => undefined}
                        //         onRefresh={() => {
                        //             onPullToRefresh()
                        //         }}
                        //     >
                        //     </PullToRefresh>
                        // }
                        // renderFooter={() => (<div style={{ padding: 0, textAlign: 'center' }}>
                        //     {loading ? 'Loading...' : '已经到底了！'}
                        // </div>)}
                        />

                    </div>

                </div>
            </div >
        </div>
    )
}
export default withRouter(Home);